import React, { useState } from 'react';
import Checkbox from '@/lib/vendor/@material-ui/core/src/Checkbox';
import Info from '@/lib/vendor/@material-ui/icons/src/Info';
import InputLabel from '@/lib/vendor/@material-ui/core/src/InputLabel';
import { TooltipSpan } from '../common/FMTooltip';
import { defineStyles } from '@/components/hooks/defineStyles';
import { useStyles } from '@/components/hooks/useStyles';

const styles = defineStyles('SignupSubscribeToCurated', (theme: ThemeType) => ({
  checkboxLabel: {
    ...theme.typography.body2,
    marginBottom: 10,
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    marginTop: 4,
    cursor: 'pointer'
  },
  checkbox: {
    paddingLeft: 0,
    paddingTop: 0,
    paddingBottom: 0,
    paddingRight: 6,
  },
  infoIcon: {
    width: 16,
    height: 16,
    verticalAlign: "middle",
    color: theme.palette.icon.dim2,
    marginLeft: 6,
  },
}));

const SignupSubscribeToCurated = ({defaultValue, onChange}: {
  defaultValue: boolean,
  onChange: (checked: boolean) => void,
}) => {
  const classes = useStyles(styles);
  const [checked, setChecked] = useState(defaultValue);

  const emailType = 'Curated posts';

  return <div>
    <InputLabel className={classes.checkboxLabel}>
      <Checkbox
        checked={checked}
        className={classes.checkbox}
        onChange={(_ev, newChecked) => {
          setChecked(newChecked)
          onChange(newChecked)
        }}
      />
      Subscribe to {emailType}
        <TooltipSpan title="Emails 2-3 times per week with the best posts, chosen by the LessWrong moderation team.">
          <Info className={classes.infoIcon}/>
        </TooltipSpan>
    </InputLabel>
  </div>
}

export default SignupSubscribeToCurated


